import React from 'react'

const Faq = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="52"
        height="52"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M9.36109 36.9159C9.36109 36.9159 5.98946 39.8983 5.70951 41.1399C5.42956 42.3815 7.91263 41.6025 7.91263 41.6025L13.3778 39.8739C13.3778 39.8739 20.4253 43.2336 26.6087 41.0912C32.792 38.9488 37.4052 35.7595 38.8658 26.4837C40.3264 17.2079 31.1732 9.27121 22.2755 9.34425C15.2523 9.40511 7.10927 12.7648 6.17203 24.8769C6.15977 29.1003 7.25967 33.2525 9.36109 36.9159Z"
            stroke="#666059"
            strokeWidth="1.625"
            strokeMiterlimit="10"
        />
        <path
            d="M19.5253 31.4371L20.2557 29.0025C20.2557 29.0025 27.4492 29.3068 28.776 24.9246C30.1027 20.5424 27.1206 18.266 25.0392 17.2922C23.1404 16.4036 17.4683 16.8661 16.7988 22.4292"
            stroke="#666059"
            strokeWidth="1.625"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M40.2761 10.2578L38 13.6175"
            stroke="#666059"
            strokeWidth="1.625"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M44.2961 15.0781L40.8027 17.1475"
            stroke="#666059"
            strokeWidth="1.625"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M46.3043 20.9336L42.2754 21.4327"
            stroke="#666059"
            strokeWidth="1.625"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M19.314 34.3465C19.3353 34.2416 19.3353 34.1261 19.3247 34.0107C19.186 32.9193 17.4373 33.1396 17.3413 34.1366C17.3093 34.5459 17.5972 34.9552 18.0024 35.0706C18.6529 35.2595 19.218 34.9237 19.314 34.3465Z"
            stroke="#686058"
            strokeWidth="1.625"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default Faq
